import apiServiceV2 from "../util/apiv2.service";
import { SERVICE_CONFIG_URLS } from "../services/config";
import utilService from "../util/utils.service";
const { createDynamicUrl } = utilService;
const profileInfoById = SERVICE_CONFIG_URLS.AUTH.UPDATE_PROFILE_INFO;
const AuthServiceV2 = {
    login,
    register,
    forgetPassword,
    emailVerification,
    resetPassword,
    verifyOtp,
    currentPass,
    updateProfileInfo,
    getProfileInfo,
    getStripeLogin,
    stripeAuthorize,
    getVendorBankDetails,
    updateVendorBankDetails,
};

async function login(payload) {
    const response = await apiServiceV2.post(
        SERVICE_CONFIG_URLS.AUTH.LOGIN,
        payload
    );
    return response;
}

async function forgetPassword(payload) {
    const response = await apiServiceV2.post(
        SERVICE_CONFIG_URLS.AUTH.FORGET_PASSWORD,
        payload
    );
    return response;
}

async function verifyOtp(payload) {
    const response = await apiServiceV2.post(
        SERVICE_CONFIG_URLS.AUTH.VERIFY_OTP,
        payload
    );
    return response;
}

async function register(payload) {
    const response = await apiServiceV2.post(
        SERVICE_CONFIG_URLS.AUTH.REGISTER,
        payload
    );
    return response;
}

async function emailVerification(token) {
    const url = `${SERVICE_CONFIG_URLS.AUTH.EMAIL_VARIFICATION}?token=${token}`;
    const response = await apiServiceV2.patch(url);
    return response;
}

async function resetPassword(payload) {
    const response = await apiServiceV2.post(
        SERVICE_CONFIG_URLS.AUTH.RESET_PASSWORD,
        payload
    );
    return response;
}

async function currentPass(payload) {
    const response = await apiServiceV2.post(
        SERVICE_CONFIG_URLS.AUTH.CURRENT_PASSWORD,
        payload
    );
    return response;
}

async function updateProfileInfo(id, payload) {
    const url = createDynamicUrl(profileInfoById, {
        id,
    });
    const response = await apiServiceV2.patch(url, payload);
    return response;
}

async function getProfileInfo() {
    const response = await apiServiceV2.get(
        SERVICE_CONFIG_URLS.AUTH.GET_PROFILE_INFO
    );
    return response;
}

async function getStripeLogin() {
    const response = await apiServiceV2.get(
        SERVICE_CONFIG_URLS.AUTH.GET_STRIPE_LOGIN
    );
    return response;
}

async function stripeAuthorize(id) {
    const response = await apiServiceV2.post(
        SERVICE_CONFIG_URLS.AUTH.STRIPE_AUTHORIZE + `?code=${id}`
    );
    return response;
}

async function updateVendorBankDetails(payload) {
    const response = await apiServiceV2.put(
        SERVICE_CONFIG_URLS.AUTH.UPDATE_BANK_DETAILS,
        payload
    );
    return response;
}

async function getVendorBankDetails() {
    const response = await apiServiceV2.get(
        SERVICE_CONFIG_URLS.AUTH.GET_BANK_DETAIL
    );
    return response;
}

export default AuthServiceV2;
